import React, { useState } from "react";
import Input from "../../../components/input";
import { ILoginDetails, TKey } from "../../../types";
import Button from "../../../components/ui/button";
import colors from "../../../utils/colors";
import { displayErrorMsg } from "../../../utils/displayErrorMsg";
import { validateEmail } from "../../../utils/validateEmail";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../apis/doctor";

const LoginForm = () => {
  const [details, setDetails] = useState<ILoginDetails>({} as ILoginDetails);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { mutate: login, isPending } = useLogin();
  const updateState = (name: TKey, value: string) => {
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isDisabled = !details?.email || !details?.password;
  return (
    <div className="w-full flex gap-[24px] flex-col">
      <div>
        <Input
          handleChange={(e) => updateState("email", e)}
          property="email"
          submitting={false}
          value={details.email}
          title="Email"
          placeholder="Enter email"
          inputStyles="p-[14px]"
        />
        {displayErrorMsg("Email can not be empty", details.email, submitting)}
        {details?.email && !validateEmail(details?.email) && (
          <div className="text-[red] text-left text-[11px]">
            Enter a valid email
          </div>
        )}
      </div>
      <div>
        <Input
          handleChange={(e) => updateState("password", e)}
          property="password"
          submitting={false}
          value={details.password}
          title="Password"
          isPassword
          placeholder="Enter password"
          inputStyles="p-[14px]"
        />
        {displayErrorMsg(
          "Password can not be empty",
          details.password,
          submitting
        )}

        <div
          className="text-xs font-lato cursor-pointer font-[700]"
          style={{ color: colors.primary }}
          onClick={() => navigate("/forgotPassword")}
        >
          Forgot/Reset password?
        </div>
      </div>

      <Button
        type="submit"
        theme="primary"
        text="Log in"
        className="w-full rounded-md"
        onClick={() => {
          setSubmitting(true);
          if (!isDisabled) {
            login({ email: details?.email, password: details?.password });
          }
        }}
        loading={isPending}
      />
    </div>
  );
};

export default LoginForm;
